import { FaArrowLeft } from "react-icons/fa6";

import Modal from "../../Reusable/Modal";
import { TransactionDetailModalInput } from "../types";

export const TransactionDetailsModal = ({
  isOpen,
  onClose,
  transaction,
}: TransactionDetailModalInput) => {
  if (!transaction) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-full max-w-lg p-0">
      <div className="flex items-center p-4 border-b dark:border-gray-700">
        <button onClick={onClose} className="mr-2">
          <FaArrowLeft size={20} className="text-gray-600 dark:text-gray-300" />
        </button>
        <h2 className="text-lg font-semibold">Transaction Details</h2>
      </div>

      <div className="p-6">
        <h3 className="text-lg font-semibold mb-4">Order Details</h3>

        <div className="mb-6">
          <p className="text-gray-500 dark:text-gray-400">
            Order ID:{" "}
            <span className="text-black dark:text-white font-medium">
              {transaction.id}
            </span>
          </p>
          <p className="text-gray-500 dark:text-gray-400">
            {transaction.date} / {transaction.time}
          </p>
        </div>

        {/* Transaction items */}
        <div className="space-y-4 mb-8">
          {transaction.items_details &&
            transaction.items_details.map((item, index) => (
              <div
                key={index}
                className="flex items-center justify-between border-b pb-4 dark:border-gray-700"
              >
                <div className="flex items-center">
                  {item.image && (
                    <div className="w-12 h-12 mr-4 overflow-hidden rounded-md">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  <div>
                    <p className="font-medium">{item.name}</p>
                    <p className="text-gray-500 dark:text-gray-400">
                      {item.username}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-blue-500">{item.currency_amount}</p>
                  <p className="font-semibold">{item.price}</p>
                </div>
              </div>
            ))}

          {/* If no item details are provided, show placeholder */}
          {(!transaction.items_details ||
            transaction.items_details.length === 0) && (
            <div className="py-4 text-center text-gray-500">
              No detailed item information available
            </div>
          )}
        </div>

        {/* Transaction summary */}
        <div className="space-y-2 border-t pt-4 dark:border-gray-700">
          <div className="flex justify-between">
            <span className="text-gray-500 dark:text-gray-400">Subtotal</span>
            <span>₦{transaction.subtotal || transaction.amount}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500 dark:text-gray-400">Fee</span>
            <span>₦{transaction.fee || "100"}</span>
          </div>
          <div className="flex justify-between border-t pt-2 mt-2 dark:border-gray-700">
            <span className="font-semibold">Total</span>
            <div className="flex items-center">
              {transaction.coin_amount && (
                <span className="text-yellow-500 mr-2">
                  🪙 {transaction.coin_amount}
                </span>
              )}
              <span className="font-semibold">
                ₦{transaction.total || transaction.amount}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
